export const REQUESTS_WITHDRAWAL_SLICE_NAME = "requestsWithdrawal"
